// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__4elR0","box":"slider_box__GdrZh","arrow":"slider_arrow__KNO+m","values":"slider_values__MyM5d"};